module.exports = __webpack_public_path__ + "img/server.4c2407bb.svg";